import { ListPageSkeleton } from '@practium/ui';

export const AnalysesPageSkeleton = () => (
	<ListPageSkeleton
		tabsCount={2}
		sidebarWidth="26rem"
		sidebarW1500="22rem"
		sidebarW1300="19rem"
		sidebarW1200="17rem"
	/>
);
